import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js";

export default function initDataPicker() {
	// flatpickr(".default-input__input--date:not([disabled])", {
	// 	"locale": Russian, 
	// 	dateFormat: "d-F-Y",
	// });

}

